import { render } from "./AsideComponent.vue?vue&type=template&id=f854e15e&scoped=true"
import script from "./AsideComponent.vue?vue&type=script&lang=js"
export * from "./AsideComponent.vue?vue&type=script&lang=js"

import "./AsideComponent.vue?vue&type=style&index=0&id=f854e15e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f854e15e"]])

export default __exports__